"use client";

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useId } from "react";

interface DynamicSelectProps {
  label?: string;
  placeholder?: string;
  options: { value: string; label: string; description?: string }[];
  selectedValue?: string | undefined;
  setSelectedValue?: (value: string | null) => void;
  isDisable?: boolean,
}


export default function DynamicSelect({
  label = "انتخاب کنید",
  placeholder = "یک گزینه انتخاب کنید",
  options,
  selectedValue,
  setSelectedValue,
  isDisable,
}: DynamicSelectProps) {
  const id = useId();

  return (
    <div className="*:not-first:mt-2 ">
      <Label htmlFor={id}>{label}</Label>
      <Select
        disabled={isDisable}
        value={selectedValue}
        onValueChange={setSelectedValue}
      >
        <SelectTrigger id={id} className="truncate **:data-desc:hidden">
          {options.find((option) => option.value === selectedValue)?.label || placeholder}
        </SelectTrigger>
        <SelectContent className="[&_[role=option]]:ps-2 [&_[role=option]]:pe-8 [&_[role=option]>span]:block">
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
              <div className="text-muted-foreground mt-1 block text-xs" data-desc>
                {option.description}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
